/**
 *
 * SelectField constants
 *
 */


export const LOAD_OPTIONS = 'claris-vnext/AdvancedForm/SelectField/LOAD_OPTIONS';
